export enum MenuStatus {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    HOVER = 'HOVER'
}
